module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modalcon"
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    style: (_vm.isSidenavOpen ? {
      width: '90%'
    } : {}),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('span', {
    staticClass: "closebtn",
    on: {
      "click": _vm.setPopup
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "mbox"
  }, [_c('div', {
    staticClass: "modal-body mb0"
  }, [_c('div', {
    staticClass: "fbold title"
  }, [_vm._v("\n              " + _vm._s(_vm.processData && _vm.processData.length ? _vm.processData[0] : '') + "\n            ")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "padding-left": "16px"
    }
  }, _vm._l((_vm.processData), function(item, index) {
    return (index !== 0) ? _c('li', {
      key: index
    }, [_vm._v("\n                " + _vm._s(item) + "\n              ")]) : _vm._e()
  }))])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25ee52bf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tssHelpDetails.vue
// module id = 1088
// module chunks = 1 14 15 17 20 21 22 23 28 36 37 45 47